module.exports = __webpack_public_path__ + "img/ex03.62182110.png";